import { getStore } from 'app/hermes-redux';
import { logout, setSessionLoadingCompleted } from 'state/session/actions';
import { performTenancyLookup, lookupKeys } from 'globals/regional-api';
import { getSubdomainFromHost } from 'router/navigation';

import USER_ROLES from 'constants/user-roles.constant';

const confirmEmailModule = {
  name: 'confirEmail',
  url: '/confirm-email',
  resolver: () => {
    // force logout, then ensure regional endpoints are set before the component mounts
    return getStore()
      .dispatch(logout({ isHard: true }))
      .then(() => {
        // logout sets session.isLoading=true with a 3-second safety timeout to clear it.
        // Since we're staying on this page (not redirecting), clear it immediately
        // so the global SpinnerFullPage doesn't overlay the confirm-email component.
        getStore().dispatch(setSessionLoadingCompleted());
        return performTenancyLookup(lookupKeys.domain, getSubdomainFromHost());
      })
      .then(
        () =>
          import(
            /* webpackChunkName: "confirm-email" */ './confirm-email-comp'
          ),
      );
  },
  data: {
    title: 'components.main_menu.confirm_email',
    authorizedRoles: [USER_ROLES.all],
  },
};

export default confirmEmailModule;
